import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import rootReducer from './reducers-index';
import { graphqlApi } from './services/graphql/api';

export default function createAppStore(preloadedState) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      const middlewares = getDefaultMiddleware().concat(graphqlApi.middleware);
      if (import.meta.env.DEV) {
        middlewares.push(logger);
      }
      return middlewares;
    },
    preloadedState,
    devTools: import.meta.env.DEV,
  });
}
